export default "__VITE_ASSET__6d4e5453__"